import PageAddHolidayPackage1 from "containers/AddListingFlows/PageAddHolidayPackage/PageAddHolidayPackage1";
import PageAddHolidayPackage2 from "containers/AddListingFlows/PageAddHolidayPackage/PageAddHolidayPackage2";
import PageAddHolidayPackage3 from "containers/AddListingFlows/PageAddHolidayPackage/PageAddHolidayPackage3";
import PageAddHolidayPackage4 from "containers/AddListingFlows/PageAddHolidayPackage/PageAddHolidayPackage4";
import PageAddHolidayPackage5a from "containers/AddListingFlows/PageAddHolidayPackage/PageAddHolidayPackage5a";
import PageAddHolidayPackage5b from "containers/AddListingFlows/PageAddHolidayPackage/PageAddHolidayPackage5b";
import PageAddHolidayPackage6 from "containers/AddListingFlows/PageAddHolidayPackage/PageAddHolidayPackage6";
import PageAddHolidayPackage7 from "containers/AddListingFlows/PageAddHolidayPackage/PageAddHolidayPackage7";
import PageAddHolidayPackage8 from "containers/AddListingFlows/PageAddHolidayPackage/PageAddHolidayPackage8";
import PageAddHolidayPackage9 from "containers/AddListingFlows/PageAddHolidayPackage/PageAddHolidayPackage9";


import { PageAddListingContextProvider } from "application/contexts/AddItemContext/PageAddListingContext";
import { Page } from "navigation/types";
import { Route, Routes } from "react-router-dom";

const AddListingPages: Page[] = [
  { path: "/add-listing-1", component: PageAddHolidayPackage1 },
  { path: "/add-listing-2", component: PageAddHolidayPackage2 },
  { path: "/add-listing-3", component: PageAddHolidayPackage3 },
  { path: "/add-listing-4", component: PageAddHolidayPackage4 },
  { path: "/add-listing-5a", component: PageAddHolidayPackage5a },
  { path: "/add-listing-5b", component: PageAddHolidayPackage5b },
  { path: "/add-listing-6", component: PageAddHolidayPackage6 },
  { path: "/add-listing-7", component: PageAddHolidayPackage7 },
  { path: "/add-listing-8", component: PageAddHolidayPackage8 },
  { path: "/add-listing-9", component: PageAddHolidayPackage9 },
]

const AddHolidayPackagePagesRouter = () => {
  return (
    <PageAddListingContextProvider>
      <Routes>
        {AddListingPages.map(({ component, path }) => {
          const Component = component;
          return <Route key={path} element={<Component />} path={path} />;
        })}
      </Routes>
    </PageAddListingContextProvider>

  )
}

export default AddHolidayPackagePagesRouter;